import { Controller } from '@hotwired/stimulus'
import { Toast } from 'bootstrap'

export default class extends Controller {
  showToast(event) {
    event.preventDefault()
    this.element.blur()

    const type = this.element.dataset.toastType || 'warning'
    const message = this.element.dataset.toastMessage
    
    if (!message) return

    const toastElement = document.getElementById(`${type}-toast`)
    const messageElement = document.getElementById(`${type}-toast-message`)

    if (!toastElement || !messageElement) return

    messageElement.textContent = message

    const toast = new Toast(toastElement)
    toast.show()
  }
}
